import { Nullable } from '@kts-front/types';
import { Group } from '@mantine/core';
import { IconArchive, IconBuilding, IconCar, IconHome, IconProps } from '@tabler/icons-react';
import * as React from 'react';

import Text from '../Text';

type PlaceTypeProps = {
  className?: string;
  name: Nullable<string> | undefined;
  size?: 'sm' | 'xs';
};

const getIconByName = (name: string): React.FC<IconProps> | null => {
  const nameLowerCase = name.toLowerCase();

  if (nameLowerCase === 'машино-место') {
    return IconCar;
  }

  if (nameLowerCase === 'жилое') {
    return IconHome;
  }

  if (nameLowerCase === 'коммерция') {
    return IconBuilding;
  }

  if (nameLowerCase === 'кладовая') {
    return IconArchive;
  }

  return null;
};

const PlaceType: React.FC<PlaceTypeProps> = ({ className, name, size }) => {
  if (!name) {
    return null;
  }

  const Icon = getIconByName(name);

  return (
    <Group align="center" gap={size === 'xs' ? 'xxxxs' : 'xxxs'} className={className}>
      {Icon && <Icon size={16} />}
      <Text size={size}>{name}</Text>
    </Group>
  );
};

export default React.memo(PlaceType);
